import { getAction, postAction, deleteAction, putAction } from '../http'

export default {
  //list
  list(params = {}, column, sortRule) {
    return getAction(`/api/design/viewComponentTag/list?column=${column}&order=${sortRule}`, params);
  },
  listExtAll(params = {}) {
    return getAction('/api/design/viewComponentExt/listAll', params);
  },
  queryById(params = {}) {
    return getAction('/api/design/component/queryById', params);
  },
  queryExtById(params = {}) {
    return getAction('/api/design/viewComponentExt/queryById', params);
  },
  //delete
  delete(params = {}) {
    return deleteAction('/api/design/component/delete', params);
  },
  //delete
  deleteBatch(params = {}) {
    return deleteAction('/api/design/component/deleteBatch', params);
  },
  import(params = {}) {
    return getAction('/api/design/component/import', params);
  },
  initPageLive(params = {}) {
    return getAction('/api/design/component/initPageLive', params);
  },
  getPageCode(params = {}) {
    return getAction('/api/design/component/get-page-code', params);
  },
  genPageCode(params = {}) {
    return postAction('/api/design/component/gen-page-code', params);
  },
  getCodeByUrlAndFrameName(params = {}) {
    return getAction('/api/design/component/getCodeByUrlAndFrameName', params);
  },
  //tag查询
  queryTagList(params = {}) {
    return getAction('/api/design/tag/list', params);
  },
  //ProjectTag查询
  queryProjectTagList(params = {}) {
    return getAction('/api/feature/projectTag/list', params);
  },
  //ComponentTag查询
  queryComponentTag(params = {}) {
    return getAction('/api/design/componentTag/list', params);
  },
  editComponent(params = {}) {
    return putAction('/api/design/component/edit', params);
  },
  //新增组件
  addComponent(params = {}) {
    return postAction('/api/design/component/add', params);
  },
  // 查询组件点赞
  listComponentLike(params = {}) {
    return getAction('/api/design/componentLike/list',params)
  },
  // 添加组件点赞
  addComponentLike(params = {}){ 
    return postAction('/api/design/componentLike/add',params)
  },
  // 编辑组件点赞
  editComponentLike(params = {}){
    return putAction("/api/design/componentLike/edit",params)
  },
  // 单个组件截图
  componentSnapshot(params = {}){
    return getAction("/api/design/component/componentSnapshot",params)
  }




}